import React from 'react';
import LOOKUP from 'constants/lookup';
import anonymousImg from 'images/anonymous.jpg';
import Button from './Button';


const CheckinPatient = (props) => {
            return (
                <div className="border_bottom_grey" >
                    <div className="checkIn_member_row">
                        <div className="float-L mr-1">
                            <h2>
                                {
                                    props.page == 1
                                    ?
                                        props.index
                                    :
                                        (props.page * 10) - (10 - props.index)
                                }
                            </h2>
                        </div>
                        <div className="">
                            {
                                props.patient.photo
                                ?
                                <span className="checkIn_list_photo_container list-item d-none-xs ml-2 mr-2">
                                    <img src={props.patient.photo} className="list-item-photo-checkin" />
                                </span>
                                :
                                <span className="checkIn_list_photo_container list-item d-none-xs">
                                    <img src={anonymousImg} className="list-item-photo-checkin" />
                                </span>
                            }
                            
                        </div>
                        
                        <div className="float-L checkIn_member_body ml-1">
                            <span>
                                <h3 className="m-0">{`${props.patient.fullName}`}</h3>
                            </span>
                            <span>
                                <p className="m-0">Member# {props.patient.id}</p>
                                <p >Age: {props.patient.age}</p>
                            </span>
                            
                            {
                                (props.patient.note) ? 
                                    <p>Note: <i>{props.patient.note}</i></p>
                                : ''
                            }
                            
                        </div>
                        
                        <div className="text-right">  
                            <Button
                                type="IconRemove"
                                className="glyphicon glyphicon-remove"
                                name="Remove"
                                onTouchTap={() => props.remove(props.patient.id)}
                            />  
                            <h4 className="green-text">Check-In at: <b>{props.patient.checkInTime.split(".")[0]}</b></h4>
                            {
                                //TODO
                                //CHECK IF CONTAINS /POS
                                window.location.pathname.includes("/pos") || window.location.pathname.includes("/pos/")
                                ?
                                    <Button
                                        className="clear-both mt-2"
                                        type="RaisedButton"
                                        labelStyle="background-color: green"
                                        label={LOOKUP.pos.patientDialog.search.addToOrderButton}
                                        onTouchTap={() => props.pos(props.patient.id)}
                                    />
                                :
                                    ""
                            }
                            
                        </div>
                    </div>
                    <div className="clear-both"></div>
                </div>
            );
        };

export default CheckinPatient;